import {ReduxStateType} from '../store';

export const selectCCHStatus = (state: ReduxStateType) => {
  return state.cchStatus;
};
